import { ISubscription } from "../../types/ISubscription";

export const DefaultSubscription: ISubscription = {
  months: 1,
  price: 379,
  discount1: 0,
  discount2: 0,
  finalPrice: 379
}
